<template>
  <div class="col-lg-8 col-xlg-9 col-md-7">
    <div class="card">
      <div class="card-body row">
        <div class="col-md-6">
          <h4 class="card-title">
            Account Information
          </h4>
          <h6 class="card-subtitle">
            Please keep your profile information always current in order to help you when you contact us.
          </h6>
        </div>
        <div v-if="!disableflag" class="col-md-6  m-b-0 text-right">
          <button class="btn btn-sm btn-secondary waves-effect waves-light text-white" @click="readOnly()">
            <i class="fas fa-arrow-left" />&nbsp; Back
          </button>
        </div>
      </div>
      <hr>
      <form class="form-horizontal">
        <div class="card-body card-blue">
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label">Name</label>
            <div class="col-sm-4 border-right-0">
              <input id="first_name" v-model="user.first_name" :disabled="disableflag" class="form-control" placeholder="First Name" type="text">
            </div>
            <div class="col-sm-4">
              <input id="last_name" v-model="user.last_name" :disabled="disableflag" class="form-control" placeholder="Last Name" type="text">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="email">Email</label>
            <div class="col-sm-8">
              <input id="email" v-model="user.email" disabled class="form-control" placeholder="Email" type="text">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="email">Phone</label>
            <div class="col-sm-8">
              <input id="text" v-model="user.org.phone" :disabled="disableflag" class="form-control" placeholder="Phone" type="text">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="line1">Address</label>
            <div class="col-sm-5">
              <input id="line1" v-model="user.org.address.line1" :disabled="disableflag" class="form-control" placeholder="Address Line 1" type="text">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="line2" />
            <div class="col-sm-5">
              <input id="line2" v-model="user.org.address.line2" :disabled="disableflag" class="form-control" placeholder="Address Line 2" type="text">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="city" />
            <div class="col-sm-5">
              <input id="city" v-model="user.org.address.city" :disabled="disableflag" class="form-control" placeholder="City" type="text">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="state" />
            <div class="col-sm-5">
              <input id="state" v-model="user.org.address.state" :disabled="disableflag" class="form-control" placeholder="State" type="text">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="postal_code" />
            <div class="col-sm-5">
              <input id="postal_code" v-model="user.org.address.zip" :disabled="disableflag" class="form-control" placeholder="Postal Code" type="text">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="country" />
            <div class="col-sm-5">
              <input id="country" v-model="user.org.address.country" :disabled="disableflag" class="form-control" placeholder="Country" type="text">
            </div>
          </div>
        </div>
        <!--                <div class="card-footer">-->
        <!--                    <div class="form-group m-b-0 text-right">-->
        <!--                        <div class="button-group" v-if="!disableflag">-->
        <!--                            <button @click="save()" class="btn waves-effect waves-light btn-success" type="button">-->
        <!--                                Save-->
        <!--                            </button>-->
        <!--                            <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">-->
        <!--                                Reset-->
        <!--                            </button>-->
        <!--                        </div>-->
        <!--                        <div class="button-group" v-if="disableflag">-->
        <!--                            <button @click="edit()" class="btn waves-effect waves-light btn-info" type="button"> Edit-->
        <!--                            </button>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MyProfile',

  data () {
    return {
      disableflag: true,
      user: {
        user: null,
        email: null,
        first_name: null,
        last_name: null,
        email2f_enabled: null,
        totp_enabled: null,
        hotp_enabled: null,
        u2f_enabled: null,
        image: null,
        email_verified: null,
        status: null,
        org: {
          name: null,
          email: null,
          web: null,
          phone: null,
          description: null,
          image: null,
          address: {
            address: null,
            line1: null,
            line2: null,
            city: null,
            state: null,
            zip: null,
            country: null
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  mounted () {
    this.getUserDetails()
  },
  methods: {
    handleLogout () {
      this.$store.commit('LOGOUT')
      this.$router.replace('/auth/login')
    },
    async getUserDetails () {
      try {
        const reply = await this.$accounts.get(`accounts/orgs/${this.currentUser.org_id}/users/${this.currentUser.id}`)
        this.user = reply.data
      } catch (error) {
        console.log(error)
      }
    },
    edit () {
      this.disableflag = false
    },
    readOnly () {
      this.disableflag = true
    },
    reset () {
      this.user = null
    }
  }
}
</script>

<style scoped>
</style>
